module.exports = __webpack_public_path__ + "img/img(33).351d45a8.jpg";